import { parseBoard } from './board';
import { getPieceOwner } from './moves';
import type { Board, PlayerNumber } from './types';

export interface PlayerSlots {
  player1_id: string | null;
  player2_id: string | null;
  player1_name: string | null;
  player2_name: string | null;
}

export function hasPlayerSlot(playerId: string | null, playerName: string | null): boolean {
  return Boolean(playerId || isFilledPlayerName(playerName));
}

export function hasTwoPlayers(game: PlayerSlots | null | undefined): boolean {
  if (!game) return false;

  return (
    hasPlayerSlot(game.player1_id, game.player1_name) &&
    hasPlayerSlot(game.player2_id, game.player2_name)
  );
}

export function getPlayerNumberForIdentity(
  game: PlayerSlots,
  identity: {
    userId?: string | null;
    guestName?: string | null;
  }
): PlayerNumber | null {
  if (identity.userId) {
    if (game.player1_id === identity.userId) return 1;
    if (game.player2_id === identity.userId) return 2;
  }

  if (identity.guestName) {
    if (game.player1_name === identity.guestName) return 1;
    if (game.player2_name === identity.guestName) return 2;
  }

  return null;
}

export function isCurrentPlayerPiece(
  board: Board | unknown,
  row: number,
  col: number,
  game: PlayerSlots,
  identity: {
    userId?: string | null;
    guestName?: string | null;
  }
): boolean {
  const parsedBoard = Array.isArray(board) ? (board as Board) : parseBoard(board);
  const playerNumber = getPlayerNumberForIdentity(game, identity);

  if (!playerNumber) return false;

  return getPieceOwner(parsedBoard[row]?.[col] ?? 0) === playerNumber;
}

function isFilledPlayerName(playerName: string | null): boolean {
  return Boolean(playerName && playerName !== 'null' && playerName.trim() !== '');
}

